export const AFC_FEE = 20;

const PHASE1 = {
  10: [10],
  20: [15, 5],
  30: [15, 10, 5],
  40: [20, 15, 5],
  50: [20, 15, 10, 5],
  60: [25, 20, 10, 5],
  70: [25, 20, 15, 5, 5],
  80: [30, 20, 15, 10, 5],
  90: [30, 25, 15, 10, 5, 5],
  100: [30, 25, 20, 15, 5, 5]
};

export function calculatePayouts (payoutMoney) {
  if (payoutMoney < 10) return [];
  if (payoutMoney <= 100) return PHASE1[payoutMoney] || [];

  if ((payoutMoney - 110) % 10 !== 0) return [];

  const step = (payoutMoney - 110) / 10;
  const b1 = Math.max(0, Math.floor((step - 2) / 4));
  const b2 = Math.max(0, Math.floor((step - 3) / 4));
  const b3 = Math.max(0, Math.floor((step - 4) / 4));
  const b4 = Math.max(0, Math.floor((step - 5) / 4));

  const top4 = [30 + 5 * b1, 25 + 5 * b2, 20 + 5 * b3, 15 + 5 * b4];
  const numFives = (payoutMoney - top4[0] - top4[1] - top4[2] - top4[3]) / 5;

  return [...top4, ...Array(numFives).fill(5)];
}